import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from "prop-types";
import {organizationSchemaOrg, SCHEMA_CONTEXT} from "../../../util/schemaOrg";

/**
 * SEO 관련 컴포넌트
 * @param metaTitle
 * @param metaDescription
 * @param metaUrl
 * @param metaImage
 * @returns {Element}
 * @constructor
 */
const BrandRankingHelmet = ({ metaTitle, metaDescription, metaUrl, metaImage }) => {
  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={metaUrl} />
      <script type="application/ld+json">
        {JSON.stringify(organizationSchemaOrg(SCHEMA_CONTEXT))}
      </script>

      <meta property="og:type" content="website" />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content="후루츠패밀리" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={metaUrl} />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={metaImage} />
      <meta property="twitter:site" content="@fruitsfamilyco" />
    </Helmet>
  );
};

BrandRankingHelmet.propTypes = {
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    metaUrl: PropTypes.string,
    metaImage: PropTypes.string
}

export default BrandRankingHelmet;
